const Constants = {
  emails: {
    support: "support@outputsports.com",
  },
  routes: {
    /**
     * Public routes
     */
    login: {
      titleKey: "pages.login_title",
      route: "/login",
    },
    hyrox: {
      titleKey: "pages.hyrox_title",
      route: "/hyrox",
    },
    join: {
      titleKey: "pages.join_title",
      route: "/join",
    },
    verifyEmail: {
      titleKey: "pages.verify_email_title",
      route: "/verify-email",
    },
    connect: {
      titleKey: "pages.connect_title",
      route: "/connect",
    },
    integrationConnect: {
      titleKey: "pages.integration_connect_title",
      route: "/integrations/:provider/connect",
    },

    /**
     * Private routes
     */
    home: {
      titleKey: "pages.home_title",
      route: "/",
    },
    live: {
      titleKey: "pages.live_title",
      route: "/live",
    },
    leaderboards: {
      titleKey: "pages.leaderboards_title",
      route: "/leaderboards",
    },
    dashboard: {
      titleKey: "pages.dashboard_title",
      route: "/dashboards",
    },
    charting: {
      titleKey: "pages.charting_title",
      route: "/charting",
    },
    exportData: {
      titleKey: "pages.export_data_title",
      route: "/export",
    },
    exerciseLibrary: {
      titleKey: "pages.exercise_library_title",
      route: "/exercise-library",
    },
    calendar: {
      titleKey: "pages.calendars_title",
      route: "/calendar",
    },
    // Private: Programs routes
    programs: {
      titleKey: "pages.programs_title",
      route: "/programs",
    },
    programsCreate: {
      titleKey: "pages.programs_create_title",
      route: "/programs/create",
    },
    programsEdit: {
      titleKey: "pages.programs_edit_title",
      route: "/programs/:programId/edit",
    },
    programsOverview: {
      titleKey: "pages.programs_overview_title",
      route: "/programs/:programId",
    },
    // Private: Athlete routes
    athletes: {
      titleKey: "pages.athletes_title",
      route: "/athlete-hub",
    },
    athletesAdd: {
      titleKey: "pages.athletes_add_title",
      route: "/athlete-hub/add",
    },
    athletesBulkUpload: {
      titleKey: "pages.athletes_bulk_upload_title",
      route: "/athlete-hub/bulk-upload",
    },
    athletesEdit: {
      titleKey: "pages.athletes_edit_title",
      route: "/athlete-hub/:id/edit/",
    },
    athletesSingle: {
      titleKey: "pages.athletes_profile_title",
      route: "/athlete-hub/:id",
    },
    /** Workout review screen, behind `workoutReviewV2Enabled`. Nothing links to it yet. */
    workoutReview_V2: {
      titleKey: "pages.workout_review_title",
      route: "/athlete-hub/:athleteId/completed-workouts/:completedWorkoutId",
    },
    bulkUpload: {
      titleKey: "pages.athletes_bulk_upload_title",
      route: "/bulk-upload",
    },
    // Private: Group routes
    groups: {
      titleKey: "group.all.page_heading_title",
      route: "/groups",
    },
    groupsAdd: {
      titleKey: "group.all.add_new_group_page_heading_title",
      route: "/groups/add",
    },
    groupsEdit: {
      titleKey: "group.overview.edit_group_page_heading",
      route: "/groups/:id/edit/",
    },
    groupsSingle: {
      titleKey: "group.overview.group_header_text",
      route: "/groups/:id",
    },
    // Private: Workouts routes
    workouts: {
      titleKey: "pages.workouts_title",
      route: "/workouts",
    },
    workoutsSingle: {
      titleKey: "pages.workout_title",
      route: "/workouts/:workoutId",
    },
    workoutsCreate: {
      titleKey: "pages.workouts_create_title",
      route: "/workouts/create",
    },
    workoutsEdit: {
      titleKey: "pages.workouts_edit_title",
      route: "/workouts/:workoutId/edit",
    },
    /**
     * Legacy completed workout page.
     * @deprecated Replaced by `workoutReview_V2` (epic OS-14000). Completed workout links switch over in OS-14071.
     */
    workoutsReview: {
      titleKey: "pages.completed_workout_overview",
      route: "/workouts/:workoutId/completed/:completedWorkoutId",
    },
    // Private: Upsell routes
    upsellOutputProgram: {
      titleKey: "upsell.output_program_page_title",
      route: "/upgrade/output-program",
    },
    upsellGroupsAndMonitoring: {
      titleKey: "upsell.groups_and_monitoring_page_title",
      route: "/upgrade/groups-and-monitoring",
    },
    // Private: Settings routes
    settings: {
      titleKey: "pages.settings_title",
      route: "/settings",
    },
    settingsSubscription: {
      titleKey: "settings.subscription_page",
      route: "/settings/subscription",
    },
    settingsAccount: {
      titleKey: "settings.account_page",
      route: "/settings/account",
    },
    settingsArchivedAthletes: {
      titleKey: "settings.archived_athletes_page",
      route: "/settings/athlete-archive",
    },
    settingsInviteAthletes: {
      titleKey: "settings.athlete_invite_page",
      route: "/settings/athlete-invite",
    },
    settingsPreferences: {
      titleKey: "settings.preferences_page",
      route: "/settings/preferences",
    },
    settingsAthleteMonitoring: {
      titleKey: "settings.athlete_monitoring_page",
      route: "/settings/athlete-monitoring",
    },
    settingsCoaches: {
      titleKey: "settings.coach_management_page",
      route: "/settings/coaches",
    },
    settingsCoachCreate: {
      titleKey: "settings.coach_create_page",
      route: "/settings/coaches/create",
    },
    settingsCoachEdit: {
      titleKey: "settings.coach_edit_page",
      route: "/settings/coaches/:coachId/edit",
    },
    notFound: {
      titleKey: "pages.not_found_title",
      route: "*",
    },
  },
};

export default Constants;
